import gql from 'graphql-tag';

export const fields = `
    engineModel {
        id
        name
    }
    chartVariable {
        id
        displayName
        variableName
    }
`;

export const relationsFields = `
`;

// default methods
export const paginationQuery = gql`
    query DigitaiPaginateEngineModelsChartVariables (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        pagination: digitaiPaginateEngineModelsChartVariables (
            query: $query
            constraint: $constraint
        ) {
            total
            rows
            count
        }
    }
`;

export const getQuery = gql`
    query DigitaiGetEngineModelsChartVariables (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        objects: digitaiGetEngineModelsChartVariables (
            query: $query
            constraint: $constraint
        ) {
            engineModelId
            chartVariableId
            #FIELDS
        }
    }
`;

export const findByIdQuery = gql`
    query DigitaiFindEngineModelChartVariableById (
        $engineModelId: ID
        $chartVariableId: ID
        $constraint: QueryStatement
    ) {
        object: digitaiFindEngineModelChartVariableById (
            engineModelId: $engineModelId
            chartVariableId: $chartVariableId
            constraint: $constraint
        ) {
            engineModelId
            chartVariableId
            #FIELDS
        }
    }
`;

export const findQuery = gql`
    query DigitaiFindEngineModelChartVariable (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        object: digitaiFindEngineModelChartVariable (
            query: $query
            constraint: $constraint
        ) {
            engineModelId
            chartVariableId
            #FIELDS
        }
    }
`;

export const createMutation = gql`
    mutation DigitaiCreateEngineModelChartVariable (
        $payload: DigitaiCreateEngineModelChartVariableInput!
    ) {
        digitaiCreateEngineModelChartVariable (
            payload: $payload
        ) {
            ${fields}
        }
    }
`;

export const insertMutation = gql`
    mutation DigitaiCreateEngineModelsChartVariables (
        $payload: [DigitaiCreateEngineModelChartVariableInput]!
    ) {
        digitaiCreateEngineModelsChartVariables (
            payload: $payload
        )
    }
`;

export const updateByIdMutation = gql`
    mutation DigitaiUpdateEngineModelChartVariableById (
        $payload: DigitaiUpdateEngineModelChartVariableByIdInput!
        $constraint: QueryStatement
    ) {
        digitaiUpdateEngineModelChartVariableById (
            payload: $payload
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const updateMutation = gql`
    mutation DigitaiUpdateEngineModelsChartVariables (
        $payload: DigitaiUpdateEngineModelsChartVariablesInput!
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiUpdateEngineModelsChartVariables (
            payload: $payload
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteByIdMutation = gql`
    mutation DigitaiDeleteEngineModelChartVariableById (
        $engineModelId: ID!
        $chartVariableId: ID!
        $constraint: QueryStatement
    ) {
        digitaiDeleteEngineModelChartVariableById (
            engineModelId: $engineModelId
            chartVariableId: $chartVariableId
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteMutation = gql`
    mutation DigitaiDeleteEngineModelsChartVariables (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiDeleteEngineModelsChartVariables (
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;
